import { FC } from 'react';
import { withStyles, MaterialSymbol } from 'vopay';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';

import styles from './Paginator.module.scss';

const classes = withStyles(styles);

type PaginatorProps = {
  pageCount: number;
  onPageChange: ReactPaginateProps['onPageChange'];
  pageOffset?: number;
};

const Paginator: FC<PaginatorProps> = ({ pageCount, onPageChange, pageOffset }) => {
  return (
    <ReactPaginate
      pageCount={pageCount}
      onPageChange={onPageChange}
      forcePage={pageOffset}
      previousLabel={
        <MaterialSymbol icon="arrow_circle_left" size="24px" fillAmount={1} className={classes('pageClassName')} />
      }
      nextLabel={
        <MaterialSymbol icon="arrow_circle_right" size="24px" fillAmount={1} className={classes('pageClassName')} />
      }
      containerClassName={classes('containerClassName')}
      breakClassName={classes('breakClassName')}
      breakLinkClassName={classes('breakLinkClassName')}
      pageClassName={classes('pageClassName')}
      pageLinkClassName={classes('pageLinkClassName')}
      activeClassName={classes('activeClassName')}
      activeLinkClassName={classes('activeLinkClassName')}
      previousClassName={classes('previousClassName')}
      nextClassName={classes('nextClassName')}
      previousLinkClassName={classes('previousLinkClassName')}
      nextLinkClassName={classes('nextLinkClassName')}
    />
  );
};

export default Paginator;
